<template>
  <div>
    <navigation-main bg="true" />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <div class="row ">
                <div class="col-12">
                  <h2 class="text-black mb-0">
                    License Agreement
                  </h2>
                  <hr
                    class="divider dark m-0 mb-1"
                    style="max-width: 100% !important;"
                  />
                </div>
                <div class="col-12">
                <p class="mb-4">
                  This Agreement is entered into between:
                </p>
                <p class="mb-4">
                  a. ETH Zurich, a university organised under Swiss public law (“ETH”); and
                </p>
                <p class="mb-4">
                  b. The individual who has been granted a license under this Agreement
                  (the “Licensee”).
                </p>
                <p class="mb-4">
                  <b>It is hereby agreed:</b>
                </p>
                <p class="mb-4">
                  It is hereby agreed:
                  ETH has developed a collection of street-level recordings or sequences of recordings
                  formatted for the purpose of research in the field of computer vision and machine
                  learning (the "Dataset"). ETH is willing to license to Licensee the use of this Dataset
                  (“License”) provided the Dataset is obtained directly from ETH, and provided Licensee
                  accepts all terms and conditions contained in this License. The term " you" and "your"
                  means the Licensee using the Dataset.
                </p>
                <p class="mb-4">
                  <b>1. Research Use License Grant</b>
                </p>
                <p class="mb-4">
                  1.1 The Dataset is made freely available to academic and non-academic entities for non-commercial
                  purposes only (such as academic research, teaching, scientific publications, or personal
                  experimentation) (the “Research Purpose”).
                </p>
                <p class="mb-4">
                  1.2 Subject to and conditional upon your compliance with the obligations included in this Agreement,
                  ETH grants to you a worldwide, royalty-free, non-sublicensable, non-transferable, and non-exclusive
                  copyright license, solely in furtherance of your Research Purpose, to download, reproduce and use the
                  Dataset.
                </p>
                <p class="mb-4">
                  <b>2. License Permission</b>
                </p>
                <p class="mb-4">
                  Permission to use the Dataset is granted to you under the following conditions:
                </p>
                <p class="mb-4">
                  2.1 The Dataset comes "AS IS", without express or implied warranty. Although every effort has been
                  made to ensure accuracy, ETH does not accept any responsibility for errors or omissions.
                </p>
                <p class="mb-4">
                  You agree to include a reference to the Dataset in any work that makes use of the Dataset. For
                  research papers, you shall cite the relevant publications as listed on the Dataset
                  <routerLink to="/citation">website</routerLink>; for other
                  media, you shall cite the relevant publications as listed on the Dataset
                  <routerLink href="/#paper">website</routerLink> or include a link to the
                  <a href="https://muses.vision.ee.ethz.ch">website</a>.
                </p>
                <p class="mb-4">
                  2.3 You agree not to share or distribute the Dataset or modified versions of it. It is permissible to
                  distribute derivative works in as far as they are abstract representations of the Dataset (such as models
                  trained on it or additional annotations that do not directly include any of our data) and they do not
                  allow to recover the dataset or something similar in character.
                </p>
                <p class="mb-4">
                  2.4 You shall not use the Dataset or any derivative work for commercial purposes as, for example,
                  licensing or selling the data, or using the Dataset with a purpose to procure a commercial gain.
                </p>
                <p class="mb-4">
                  2.5 You expressly may not use the Dataset or any derivative work thereof for any military purposes or
                  applications or pursue any other non-civil, non-ethical, immoral, or other use that wilfully endangers
                  life or property.
                </p>
                <p class="mb-4">
                  2.6 All rights not expressly granted to you are reserved by ETH.
                </p>
                <p class="mb-4">
                  <b>3. Export Control</b>
                </p>
                <p class="mb-4">
                  The Licensee shall strictly comply with all applicable export control laws and regulations in force that
                  may apply to this license agreement. Export control includes national and international laws and
                  regulations, such as but not limited to U.S. Export Administration Regulations, which impose arms
                  embargoes and control the export of goods, technology, or software for the development, production
                  or use of military, paramilitary, and security equipment and dual-use items that are designed for civil
                  use but which can be used for military purposes ("Export Control Regulations").
                </p>
                <p class="mb-4">
                  <b>4. Liability</b>
                </p>
                <p class="mb-4">
                  4.1 ETH will not be held liable for any direct, indirect, incidental, special, consequential or exemplary
                  damages, or cost of procurement of substitute services, or damages for loss of revenue, profits,
                  goodwill, use, data or other intangible losses (even if ETH has been advised of the possibility of such
                  damages), resulting from the use of or inability to use the Dataset or the exercise of the licensed rights
                  granted hereunder.
                </p>
                <p class="mb-4">
                  4.2 Any use of the License in a manner not expressly authorized by this Agreement or in breach of this
                  Agreement constitutes an infringement, entitling ETH to exercise all rights and remedies available
                  under the applicable laws as defined in section 6 of this Agreement.
                </p>
                <p class="mb-4">
                  4.3 The Licensee shall indemnify ETH in respect of all costs, claims, losses, expenses or damage arising
                  as a result of the Licensee failing to comply with their obligations under this Agreement.
                </p>
                <p class="mb-4">
                  <b>5. Assignment</b>
                </p>
                <p class="mb-4">
                  The License shall not be assigned or transferred, nor its rights or obligations, by Licensee without the
                  prior and express written consent of ETH. Any assignment made in violation of this section will be void.
                  ETH may freely assign this License without the necessity for consent.
                </p>
                <p class="mb-4">
                  <b>6. Governing Law</b>
                </p>
                <p class="mb-4">
                  This Agreement will be governed by and construed under the laws of Switzerland. Any disputes arising
                  from this Agreement or its enforceability shall be tried to be amicably settled by the parties at first. If
                  the parties cannot find an agreement, place of jurisdiction shall be Zurich, Switzerland.
                </p>
                </div>
                
              </div>

            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  name: "LicensePage.vue",
  components: {
    NavigationMain
  }
};
</script>
